/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actionTypes from './actionTypes';

function reducer(state:{ packSites: [] }, action:{ payload: any, type: string }) {
  switch (action.type) {
    case actionTypes.SET_PACKSITES:
      return {
        ...state,
        packSites:  action.payload,
      };

    case actionTypes.APPEND_PACKSITES:
      return {
        ...state,
        packSites:  [...state.packSites, ...action.payload],
      };

    case actionTypes.SET_NO_MORE_PACKSITE:
      return {
        ...state,
        noMorePacksites:  action.payload,
      };

    case actionTypes.SET_PACKSITE_FILTERS:
      return {
        ...state,
        packDetailFilters: action.payload,
      };
  
    case actionTypes.SET_PACKSITE_STATE:
      return {
        ...state,
        packSitesState: action.payload,
      };
      
    default:
      return state;
  }
}

export default reducer;
